export default "__VITE_ASSET__DTQTTJfk__"